import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: 'yzsc780b',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skYEIONIBPGCNM5nEY6ZKYYmq4XhBvTzQT1SjhjarFfPBHvxTOOJvPK5NioUiOLMCIwQkUbT9ZgmOzlqIpmx74tsJfVBGZIVicdz72sbfk0hRvRpcrW8odOmS8065MZiZeh775niMzJqcvyo5PbUNfzFmgOgnABMjTv2nfIFkeGhlh486hrj',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);